import React, { useMemo } from "react";
import CustomCard from "../Card";
import { EChartsOption } from "echarts";
import ReactEchart from "../../../../molecules/ReactEchart";

const StatusCard: React.FC = React.memo(() => {
  const options: EChartsOption = useMemo(() => {
    const fullLabels = [
      "Issue Resolved",
      "Reject",
      "Landlord not Responsible",
      "Bar Code Scanned",
      "Pending Confirmation",
      "Acknowledged",
      "Ticket Type Confirmed",
      "Bar Code Scanned",
      "Initial assessment",
      "Issue not Resolved",
    ];

    const shortLabels = [
      "Resolved",
      "Reject",
      "Not Resp.",
      "Scanned",
      "Pending",
      "Ack.",
      "Confirmed",
      "Scanned",
      "Assess.",
      "Not Resolved",
    ];

    const isMobile = window.innerWidth < 600;
    const labels = isMobile ? shortLabels : fullLabels;

    return {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: (params: any) => {
          const { name, value } = params[0];
          return `${name}: ${value}`;
        },
      },
      grid: {
        left: "5%",
        right: "10%",
        bottom: "5%",
        containLabel: true,
      },
      xAxis: {
        type: "value",
        splitLine: { show: false },
      },
      yAxis: {
        type: "category",
        inverse: true,
        data: labels,
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: {
          fontSize: 14,
          color: "#1F5782",
        },
      },
      series: [
        {
          type: "bar",
          data: [300, 500, 900, 500, 210, 390, 600, 150, 780, 200],
          barWidth: "50%",
          itemStyle: {
            borderRadius: [5, 5, 5, 5],
            color: "#1F5782",
          },
          label: {
            show: true,
            position: "right",
            fontSize: 14,
            fontWeight: "bold",
            formatter: ({ value }) => `(${value})`,
            color: "#1F5782",
          },
        },
      ],
    };
  }, []);

  return (
    <CustomCard heading="CASE /" subHeading="STATUS">
      <ReactEchart
        options={options}
        style={{ height: "400px", width: "100%" }}
      />
    </CustomCard>
  );
});

export default StatusCard;
